;var BiographyPosition = (function() {

  var percentage = 0;
  var animation = null;

  function incrementPixels( _pixels ) {
    set( percentage + _pixels / getMaxTranslate() );
  }

  function incrementPercent( _percentage ) {
    set( percentage + _percentage );
  }

  function goToNextCard() {
    var biographyPosition = percentage * getMaxTranslate();
    var cards = $( '.container-biografia .cards-biografia > div' );

    for (var i = 0; i < cards.length; i++) {
      var cardPosition = $(cards[i]).position().left;
      if (cardPosition > biographyPosition) {
        tween( cardPosition );
        return;
      }
    }
  }

  function goToPreviousCard() {
    var biographyPosition = percentage * getMaxTranslate();
    var cards = $( '.container-biografia .cards-biografia > div' );

    for (var i = cards.length - 1; i >= 0; i--) {
      var cardPosition = $(cards[i]).position().left;
      if (cardPosition < biographyPosition) {
        tween( cardPosition );
        return;
      }
    }
  }

  function tween( _pixels ) {
    if ( animation ) {
      animation.pause();
    }

    var objectPosition = {
      percentage: percentage
    }

    animation = anime({
      targets: objectPosition,
      percentage: _pixels / getMaxTranslate(),
      duration: 300,
      easing: 'easeOutExpo',
      update: function() {
        set( Number(objectPosition.percentage) );
      }
    });
  }

  function set( _percentage ) {
    percentage = _percentage;

    if ( percentage < 0 ) {
      percentage = 0;
    }

    if ( percentage > 1 ) {
      percentage = 1;
    }

    if ( getMaxTranslate() < 0 ) {
      return;
    }
    
    var translateBiography = -(percentage * getMaxTranslate());

    $( '.container-biografia .cards-biografia' ).css( 
      'transform', 'translate('+ translateBiography + 'px, -50%)'
    );

    var markerWidth = $( '.container-biografia .drag .marker' ).innerWidth();
    var dragWidth = $( '.container-biografia .drag' ).innerWidth();
    var translateMarker = ( ( dragWidth - markerWidth ) * percentage );

    $( '.container-biografia .drag .marker' ).css( 'left', translateMarker );
  }

  function getMaxTranslate() {
    return $( '.container-biografia .cards-biografia' ).innerWidth() - 680;// 680 to align right with container
  }

  return {
    incrementPixels: incrementPixels,
    incrementPercent: incrementPercent,
    goToNextCard: goToNextCard,
    goToPreviousCard: goToPreviousCard,
    set: set,
  }

})();